import { useState } from "react";
import { CalendarCheck, Loader2 } from "lucide-react";

const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-NZ", { weekday: "short", day: "numeric", month: "short" });

export const DeliveryCell = ({ order, onSet }) => {
  const [date, setDate] = useState(order.confirmed_delivery_date ?? "");
  const [busy, setBusy] = useState(false);
  const changed = date && date !== order.confirmed_delivery_date;

  const save = async () => {
    setBusy(true);
    await onSet(order.id, date);
    setBusy(false);
  };

  return (
    <div className="grid gap-2">
      {order.delivery_day && <p className="text-[var(--sage)]">Prefers {order.delivery_day}</p>}
      {order.confirmed_delivery_date && (
        <p className="flex items-center gap-1.5 font-semibold text-emerald-300" data-testid={`admin-delivery-confirmed-${order.ref}`}>
          <CalendarCheck className="h-4 w-4" /> {fmt(order.confirmed_delivery_date)}
        </p>
      )}
      <div className="flex items-center gap-2">
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="rounded-lg border border-white/10 bg-black/30 px-2 py-1.5 text-xs text-white [color-scheme:dark]" data-testid={`admin-delivery-date-${order.ref}`} />
        <button onClick={save} disabled={!changed || busy} className="rounded-full bg-[var(--gold)] px-3 py-1.5 text-xs font-bold text-[#0F1410] transition-opacity disabled:opacity-30" data-testid={`admin-delivery-save-${order.ref}`}>
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Set & email"}
        </button>
      </div>
    </div>
  );
};
